'use client';
import { Portal } from '@headlessui/react';

const FullScreenLoading = ({ children = '' }: { children?: React.ReactNode }) => {
  return (
    <Portal>
      <div className="fixed z-50 top-0 left-0 w-dvw h-dvh bg-white">
        <div className="flex flex-col justify-center items-center gap-4 h-full">
          <span className="loader" />
          <div>{children}</div>
        </div>
      </div>
    </Portal>
  );
};

export default FullScreenLoading;
